import React, { useState } from "react";
import { Link } from "@mui/material";
import { blue } from "@mui/material/colors";

interface TextWithShowMoreProps {
    text: string;
    maxLength?: number;
}

const TextWithShowMore: React.FC<TextWithShowMoreProps> = ({
    text,
    maxLength = 100,
}) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const renderText = () => {
        if (text.length <= maxLength) {
            return text;
        }

        if (isExpanded) {
            return text;
        }

        return text.slice(0, maxLength) + "...";
    };

    return (
        <div>
            <p>
                <span>{renderText()}</span>
                {text.length > maxLength && (
                    <Link
                        component="button"
                        sx={{ cursor: "pointer", ml: 0.5, mt: -0.25 }}
                        color={blue[700]}
                        onClick={toggleExpand}
                    >
                        {isExpanded ? "Show less" : "Show more"}
                    </Link>
                )}
            </p>
        </div>
    );
};

export default TextWithShowMore;
